import { useSelector } from "react-redux";

function IntroArea() {
  // overall preview state
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  const currentPreviewState = useSelector((state) => state.cardPreview);

  const currentProduct = currentRequest.Products['card'];

  return (
    <div className="intro-area">
      <img alt={currentProduct.DefaultRightPanelText} src={currentProduct.DefaultRightPanelImage} />
      <div className="intro-area-summary">{currentProduct.DefaultRightPanelText}</div>
    </div>
  );
}

export default IntroArea;
